// extracted by mini-css-extract-plugin
export default {"selected":"Addressbook_selected__QdPRF","click":"Addressbook_click__upHjx"};